import dayjs from "dayjs";

export const capitalizarPrimeraLetra = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
export const obtenerNombreDia = (fecha) => {
  let dia = "";
  switch (fecha) {
    case "lunes":
      dia = "Lunes";
      break;
    case "martes":
      dia = "Martes";
      break;
    case "miércoles":
      dia = "Miércoles";
      break;
    case "jueves":
      dia = "Jueves";
      break;
    case "viernes":
      dia = "Viernes";
      break;
    case "sábado":
      dia = "Sábado";
      break;
    case "domingo":
      dia = "Domingo";
      break;
  }
  return dia;
};

function parseSpecial(rtf) {
  // Encontrar todas las secuencias \'xx
  let matches = rtf.match(/\\'[a-f0-9]{2}/g);
  // Eliminar duplicados en el arreglo
  let special = [...new Set(matches)];
  // Recorrer para remplazar
  special.forEach((hex) => {
    // Convertir de hexadecimal a decimal, eliminando primero la marca \'
    let dec = parseInt(hex.replace("\\'", ""), 16);
    // Remplazar secuencia por caracter correspondiente
    rtf = rtf.replaceAll(hex, String.fromCharCode(dec));
  });
  return rtf;
}
export function convertToPlain(rtf) {
  if (rtf) {
    // Interpretar contenido original
    rtf = rtf.replace(/\\par[d]?/g, "");
    rtf = rtf.replace(/\{\*?\\[^{}]+}|[{}]|\\\n?[A-Za-z]+\n?(?:-?\d+)?[ ]?/g, "").trim();
    // Buscar secuencias de caracteres especiales y devolver
    return parseSpecial(rtf);
  } else {
    return "-";
  }
}
export function parseHorario(horarioStr) {
  if (!horarioStr || horarioStr.trim() === "") return { desde: null, hasta: null };

  const partes = horarioStr.match(/De (\d{2}:\d{2}) a (\d{2}:\d{2})/);
  if (!partes) return null;
  let resultado = {
    desde: partes[1],
    hasta: partes[2],
  };
  return resultado;
}
export function HoraDentrodelLimite(hora, limite) {
  if (!hora || !limite) return false;

  const horaDesde = parseHorario(limite)?.desde;
  const horaHasta = parseHorario(limite)?.hasta;
  if (!horaDesde || !horaHasta) return true;

  const [desdeH, desdeM] = horaDesde.split(":").map(Number);
  const [hastaH, hastaM] = horaHasta.split(":").map(Number);
  const desdeEnMinutos = desdeH * 60 + desdeM;
  const hastaEnMinutos = hastaH * 60 + hastaM;

  const horaFormateada = dayjs(hora, "HH:mm").format("HH:mm");
  const horaEnMinutos = parseInt(horaFormateada.split(":")[0]) * 60 + parseInt(horaFormateada.split(":")[1]);
  if (isNaN(horaEnMinutos)) return false;

  return horaEnMinutos >= desdeEnMinutos && horaEnMinutos <= hastaEnMinutos;
}
